import React from 'react';
import {ReconnectAdAccountModal} from '../connections/ReconnectAdAccountModal';
import {EditSheetAdAccountModal} from '../../channels/sheet/EditSheetAdAccountModal';

/**
 * El modal que recupera o mantiene una cuenta, UNO para toda la pantalla: la fila y el drawer lo
 * piden con `{row, kind}`. `kind` lo deciden `reconnectKindOf` (cuenta caída) o `maintenanceKindOf`
 * (planilla o tienda al día, review C-04).
 *
 * Los modales son los de siempre, con los mismos datos que les pasa la pantalla clásica:
 * `ClientAdAccountRow` (cuentas y planillas) y `ClientStoreRow` (tiendas). Donde aquélla recargaba
 * la página entera al terminar, acá se refresca la lista.
 *
 * `agency_channel_credential_label` viaja como en la fila clásica: es el acceso de ESTA agencia (el
 * presenter lo lee del `AgencyAdAccountStatus` de la agencia de quien mira), no puede nombrar otro.
 */
export function ReconnectHost({target, onClose, onDone}) {
    if (!target || !target.row) return null;
    const raw = target.row.raw || {};

    if (target.kind === 'sheet') {
        return <EditSheetAdAccountModal isOpen={true} onToggle={onClose} adAccountPk={raw.ad_account_id} onSaved={onDone}/>;
    }
    if (target.kind === 'store') {
        return <ReconnectAdAccountModal isOpen={true} onToggle={onClose} adAccountData={raw} onReconnected={onDone}/>;
    }
    if (target.kind === 'oauth') {
        return (
            <ReconnectAdAccountModal isOpen={true} onToggle={onClose} onReconnected={onDone}
                                     adAccountData={{
                                         ad_account_id: raw.ad_account_id,
                                         name: raw.name,
                                         channel: raw.channel,
                                         agency_channel_credential_label: raw.agency_channel_credential_label,
                                         error_found: raw.error_found,
                                         error_kind: raw.error_kind,
                                         // Quién ve la cuenta y desde cuándo (UD-20): el modal lo dice.
                                         platform_user_name: raw.platform_user_name,
                                         connected_by_user_name: raw.connected_by_user_name,
                                         no_access_since_at: raw.no_access_since_at,
                                     }}/>
        );
    }
    return null;
}
